var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isListenerMobile)?_c('ListenerFavourites'):_c('Favourites')
}
var staticRenderFns = []

export { render, staticRenderFns }